import { render, staticRenderFns } from "./setting-userinfo.vue?vue&type=template&id=283f265d&"
import script from "./setting-userinfo.vue?vue&type=script&lang=js&"
export * from "./setting-userinfo.vue?vue&type=script&lang=js&"
import style0 from "./setting-userinfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports